import * as React from "react";

import {Row, WideContent} from "@pg-design/grid-module";

import {ColumnListItem} from "../atoms/ColumnListItem";
import {OfferBoxPlaceholder} from "../offer/atoms/OfferBoxPlaceholder";

const times = 3;

export const NearbyOffersPanelPlaceholder = () => {
    return (
        <WideContent>
            <Row>
                {[...Array(times)].map((elem, index) => (
                    <ColumnListItem key={index}>
                        <OfferBoxPlaceholder key={index} />
                    </ColumnListItem>
                ))}
            </Row>
        </WideContent>
    );
};
import * as React from "react";

import {Row, WideContent} from "@pg-design/grid-module";

import {ColumnListItem} from "../atoms/ColumnListItem";
import {OfferBoxPlaceholder} from "../offer/atoms/OfferBoxPlaceholder";

const times = 3;

export const NearbyOffersPanelPlaceholder = () => {
    return (
        <WideContent>
            <Row>
                {[...Array(times)].map((elem, index) => (
                    <ColumnListItem key={index}>
                        <OfferBoxPlaceholder key={index} />
                    </ColumnListItem>
                ))}
            </Row>
        </WideContent>
    );
};
